export const FETCH_START = 'fetchStartTicketUsers';
export const FETCH_END = 'fetchEndTicketUsers';
export const SET_USERS = 'setTicketUsers';